import React from "react";
import { SystemOverviewContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import moment from "moment";
import {
  GraphAreaWidget,
  // PieDonutWidget
} from "widgets";
import { Cards, Displays, Inputs } from "components";

class SystemOverviewContainer extends React.Component {
  state = { isLoading: true };

  componentDidMount() {
    scrollToTopPageFN();
    this.fetchData(
      `?pagination=false&period=month&start_date=${moment()
        .startOf("month")
        .format("YYYY-MM-DD")}&end_date=${moment()
        .endOf("month")
        .format("YYYY-MM-DD")}`
    );
  }

  fetchData = async (stringQuery) => {
    let resArr = await Promise.all([
      portalService.GET_SYSTEM_OVERVIEW(stringQuery),
      portalService.GET_SYSTEM_OVERVIEW_PERIOD(stringQuery),
    ]);
    if (resArr) {
      this.setState({
        data: resArr[0].data,
        // pieDonutGraphData: {
        //   labels: [
        //     "MEMBERS",
        //     "WARRANTY REGISTERED AMOUNT",
        //     "WARRANTY APPROVED AMOUNT",
        //     "ACTIVITY",
        //     "POINT OF REDEMPTION",
        //   ],
        //   series: [
        //     resArr[0].data.customerCount || 0,
        //     resArr[0].data.productWarranteeRegisteredCount || 0,
        //     resArr[0].data.productWarranteeApproveCount || 0,
        //     resArr[0].data.activityHistoryCount || 0,
        //     resArr[0].data.rewardHistoryCount || 0,
        //   ],
        // },
        areaGraphData: {
          categories: resArr[1].data.pattern,
          series: resArr[1].data.dataList.map((e) => ({
            name: e.cate,
            data: e.data.map((f) => (f.userCount ? f.userCount : 0)),
          })),
        },
        isLoading: false,
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleJoinQuery = (query) => {
    let joinQuery = query ? `${query}&pagination=false` : `?pagination=false`;
    this.setState({
      isLoading: true,
    });
    this.fetchData(joinQuery);
  };

  render() {
    const { isLoading, data, areaGraphData } = this.state;
    return (
      <SystemOverviewContainerStyled>
        <div className="filter_layout">
          <Inputs.InputFilter
            theme_standard_input_filter
            dataFilter={dataFilter}
            btnLabel="ค้นหา"
            onQueryFilter={this.handleFilterKeyword}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="body_layout">
              <div className="score_row">
                <Cards.ScoreBlock label="MEMBERS" value={data.customerCount} />
                <Cards.ScoreBlock
                  label="PRODUCT-REGISTERED MEMBER"
                  value={data.customerRegisted}
                />
                <Cards.ScoreBlock
                  label="WARRANTY REGISTERED AMOUNT"
                  value={data.productWarranteeRegisteredCount}
                />
                <Cards.ScoreBlock
                  label="WARRANTY APPROVED AMOUNT"
                  value={data.productWarranteeApproveCount}
                />
                <Cards.ScoreBlock
                  label="ACTIVITY"
                  value={data.activityHistoryCount}
                />
                <Cards.ScoreBlock
                  label="POINT OF REDEMPTION"
                  value={data.rewardHistoryCount}
                />
              </div>
              {/* <div className="bl_row">
                <PieDonutWidget data={pieDonutGraphData} graphType="overview" />
              </div> */}
              {/* <div className="bl_row"> */}
              <GraphAreaWidget data={areaGraphData} />
              {/* </div> */}
            </div>
          </>
        )}
      </SystemOverviewContainerStyled>
    );
  }
}

const dataFilter = [
  {
    accessor: "dateBy",
    placeHolder: "ระยะเวลา",
    filter: {
      defaultValue: {
        level1: "month",
        level2: new Date(moment().format("YYYY-MM-DD")),
      },
      fieldQuery: "period",
      type: "dateGroup",
      placeholder: "เลือก",
      options: [
        { label: "Over All", value: "all" },
        { label: "Today", value: "day" },
        { label: "Year", value: "year" },
        { label: "Month", value: "month" },
        { label: "Quarter", value: "quarter" },
        { label: "Period", value: "date_range" },
      ],
    },
  },
];

export default withRouter(SystemOverviewContainer);
